"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRetryMiddleware = exports.createHeadersMiddleware = exports.createGraphQLMiddleware = exports.createErrorMiddleware = exports.createAuthenticationMiddleware = exports.createClient = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _apolloClient = require("apollo-client");

var _apolloCacheInmemory = require("apollo-cache-inmemory");

var _apolloLink = require("apollo-link");

var _apolloLinkContext = require("apollo-link-context");

var _apolloLinkError = require("apollo-link-error");

var _apolloLinkHttp = require("apollo-link-http");

var _apolloLinkRetry = require("apollo-link-retry");

var _lodash = _interopRequireDefault(require("lodash.merge"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var createErrorMiddleware = function createErrorMiddleware(_ref) {
  var onError = _ref.onError;
  return (0, _apolloLinkError.onError)(function (options) {
    return onError(options);
  });
};

exports.createErrorMiddleware = createErrorMiddleware;

var createRetryMiddleware = function createRetryMiddleware(_ref2) {
  var delay = _ref2.delay,
      attempts = _ref2.attempts;
  return new _apolloLinkRetry.RetryLink({
    delay: delay,
    attempts: attempts
  });
};

exports.createRetryMiddleware = createRetryMiddleware;

var createGraphQLMiddleware = function createGraphQLMiddleware(_ref3) {
  var uri = _ref3.uri;
  return new _apolloLinkHttp.HttpLink({
    uri: uri
  });
};

exports.createGraphQLMiddleware = createGraphQLMiddleware;

var createHeadersMiddleware = function createHeadersMiddleware(_ref4) {
  var getHeaders = _ref4.getHeaders;
  return (0, _apolloLinkContext.setContext)(
  /*#__PURE__*/
  function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee(request) {
      var headers;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getHeaders();

            case 2:
              headers = _context.sent;
              return _context.abrupt("return", {
                headers: _objectSpread({}, request.headers, {}, headers)
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }());
};

exports.createHeadersMiddleware = createHeadersMiddleware;

var createAuthenticationMiddleware = function createAuthenticationMiddleware(_ref6) {
  var getToken = _ref6.getToken;
  return createHeadersMiddleware({
    getHeaders: function () {
      var _getHeaders = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2() {
        var token;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getToken();

              case 2:
                token = _context2.sent;
                return _context2.abrupt("return", {
                  Authorization: token
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getHeaders() {
        return _getHeaders.apply(this, arguments);
      }

      return getHeaders;
    }()
  });
};

exports.createAuthenticationMiddleware = createAuthenticationMiddleware;
var DEFAULT_OPTIONS = {
  watchQuery: {
    fetchPolicy: 'cache-first'
  }
};

var createClient = function createClient() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$middleware = config.middleware,
      middleware = _config$middleware === void 0 ? [] : _config$middleware,
      _config$cacheOptions = config.cacheOptions,
      cacheOptions = _config$cacheOptions === void 0 ? {} : _config$cacheOptions,
      _config$defaultOption = config.defaultOptions,
      defaultOptions = _config$defaultOption === void 0 ? {} : _config$defaultOption,
      options = (0, _objectWithoutProperties2["default"])(config, ["middleware", "cacheOptions", "defaultOptions"]);
  return new _apolloClient.ApolloClient(_objectSpread({
    link: _apolloLink.ApolloLink.from(middleware),
    cache: new _apolloCacheInmemory.InMemoryCache(_objectSpread({
      addTypename: true
    }, cacheOptions)),
    defaultOptions: (0, _lodash["default"])({}, DEFAULT_OPTIONS, defaultOptions)
  }, options));
};

exports.createClient = createClient;